(function (win) {
    win.LBSApp = win.LBSApp || {};
    win.LBSApp.Components = win.LBSApp.Components || {};

    win.LBSApp.Components.Navigation = function (
        menuContainerEl,
        siteContainerEl,
        headerContainerEl
    ) {
        if (!headerContainerEl) {
            return;
        }

        const elements = initializeElements(menuContainerEl, siteContainerEl, headerContainerEl);
        
        // State
        let isMenuOpen = false;
        const originalTabIndexes = new Map();
        
        // Initialize component
        function init() {
            storeOriginalTabIndexes();
            setTabIndex(elements.focusableElementsInMenu, false);
            attachEventListeners();
        }

        function initializeElements(menuContainer, siteContainer, headerContainer) {
            const focusableElementsSelector = 'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"]), video';

            const menuButton = siteContainerEl.querySelector('#navigation-menu-toggle-btn');
            const menuFocusableElements = Array.from(menuContainer.querySelectorAll(focusableElementsSelector));
            const allFocusableElements = Array.from(document.querySelectorAll(focusableElementsSelector))
                .filter(element => 
                    !menuFocusableElements.includes(element) && element !== menuButton
                );
            
            return {
                menuButton: menuButton,
                menuButtonTitle: menuButton.querySelector('.js-Header-title--menu'),
                menuContainer: menuContainer,
                overlayContainer: menuContainer.querySelector('.js-Menu-overlay'),
                siteContainer: siteContainer,
                main: siteContainerEl.querySelector('main'),
                footer: siteContainerEl.querySelector('footer'),
                header: headerContainer,
                focusableElementsInMenu: menuFocusableElements,
                focusableElementsOnSite: allFocusableElements,
                headerFocusableElements: Array.from(headerContainer.querySelectorAll('a, button:not(#navigation-menu-toggle-btn)'))
            };
        }
        
        function storeOriginalTabIndexes() {
            elements.focusableElementsOnSite.forEach(item => {
                originalTabIndexes.set(item, item.getAttribute('tabindex'));
            });
        }
        
        function attachEventListeners() {
            elements.menuButton.addEventListener('click', toggleMenu);
            elements.overlayContainer.addEventListener('click', toggleMenu);
            
            elements.menuContainer.querySelectorAll('.menu-collapsable-btn').forEach(btnEl => {
                $(btnEl).click(function() {
                    $(this).next().slideToggle();
                    $(this).toggleClass('children-open');
                    toggleAriaExpanded(btnEl);
                });
            });
        }

        function toggleMenu() {
            isMenuOpen ? closeMenu() : openMenu();
        }
        
        function openMenu() {
            setTabIndex(elements.focusableElementsOnSite, false);
            setTabIndex(elements.focusableElementsInMenu, true);
            setAriaHidden(true);
            elements.menuButtonTitle.innerText = "Stäng";
            elements.menuContainer.classList.add('Menu--open');
            elements.siteContainer.classList.add('locked');
            elements.menuButton.classList.add('Burger--open', 'active');
            
            document.addEventListener('keydown', handleKeyDown);
            toggleAriaExpanded(elements.menuButton);
            
            isMenuOpen = true;
        }
        
        function closeMenu() {
            setTabIndex(elements.focusableElementsInMenu, false);
            restoreOriginalTabIndexes();
            setAriaHidden(false);
            elements.menuButtonTitle.innerText = "Meny";
            elements.menuContainer.classList.remove('Menu--open');
            elements.siteContainer.classList.remove('locked');
            elements.menuButton.classList.remove('Burger--open', 'active');
            
            document.removeEventListener('keydown', handleKeyDown);
            toggleAriaExpanded(elements.menuButton);
            
            isMenuOpen = false;
        }
        
        function restoreOriginalTabIndexes() {
            elements.focusableElementsOnSite.forEach(item => {
                const originalTabIndex = originalTabIndexes.get(item);
                if (originalTabIndex !== null) {
                    item.setAttribute('tabindex', originalTabIndex);
                } else {
                    item.removeAttribute('tabindex');
                }
            });
        }

        function setTabIndex(els, tabbable) {
            els.forEach(el => {
                if (tabbable) {
                    el.removeAttribute('tabindex');
                } else {
                    el.setAttribute('tabindex', '-1');
                }
            });
        }

        function setAriaHidden(shouldOpen) {
            const outerElements = [...elements.headerFocusableElements, elements.main, elements.footer];
            if (shouldOpen) {
                elements.menuContainer.removeAttribute('aria-hidden');
                outerElements.forEach(el => el.setAttribute('aria-hidden', 'true'));
            }
            else {
                elements.menuContainer.setAttribute('aria-hidden', 'true');
                outerElements.forEach(el => el.removeAttribute('aria-hidden'));
            }
        }

        function handleKeyDown(event) {
            if (event.key === 'Escape') {
                closeMenu();
            }
        }

        function toggleAriaExpanded(el) {
            const isExpanded = el.getAttribute('aria-expanded') === 'true';
            el.setAttribute('aria-expanded', !isExpanded);
        }

        // Initialize the component
        init();
        
        return {
            toggleMenu
        };
    };
})(window);